import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play, Pause } from "lucide-react";

const PHASES = [
  { label: "Inspira", secs: 4, scale: 1 },
  { label: "Trattieni", secs: 2, scale: 1 },
  { label: "Espira", secs: 6, scale: 0.55 },
];

export const Breathing = () => {
  const [on, setOn] = useState(false);
  const [phase, setPhase] = useState(2);

  useEffect(() => {
    if (!on) return;
    const t = setTimeout(() => setPhase((p) => (p + 1) % PHASES.length), PHASES[phase].secs * 1000);
    return () => clearTimeout(t);
  }, [on, phase]);

  const toggle = () => { setOn((v) => !v); setPhase(on ? 2 : 0); };
  const p = PHASES[phase];

  return (
    <div className="rounded-[2rem] border border-[#FCFBF7]/10 bg-[#FCFBF7]/[0.04] p-8 flex flex-col items-center text-center" data-testid="breathing-widget">
      <p className="eyebrow text-[#86C89B]">Un minuto per te</p>
      <div className="relative w-56 h-56 my-8 grid place-items-center">
        <div className="absolute inset-0 rounded-full border border-[#86C89B]/20" />
        <motion.div
          animate={{ scale: on ? p.scale : 0.55 }}
          transition={{ duration: on ? p.secs : 0.8, ease: "easeInOut" }}
          className="absolute inset-0 rounded-full bg-[radial-gradient(circle,rgba(134,200,155,0.55),rgba(62,107,72,0.25)_60%,transparent_72%)]"
        />
        <span className="relative f-serif italic text-3xl text-[#FCFBF7]" data-testid="breathing-phase">{on ? p.label : "Respira"}</span>
      </div>
      <p className="text-sm text-[#FCFBF7]/60 max-w-xs">La stessa respirazione che proviamo insieme, in poltrona, prima di iniziare.</p>
      <button
        onClick={toggle}
        data-testid="breathing-toggle-btn"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#86C89B] text-[#0F2317] px-6 py-3 text-sm font-medium hover:bg-[#FCFBF7] transition-colors"
      >
        {on ? <Pause size={15} /> : <Play size={15} />} {on ? "Pausa" : "Inizia a respirare"}
      </button>
    </div>
  );
};
